// src/pages/admin/AdminProyecto/AdminProyecto.js
//
// Página del panel SUPERADMIN que muestra el documento estratégico
// de HolaVeci v5.0 en formato interactivo con 3 tabs.
// Contenido idéntico al HolaVeci_DocumentoEstrategico_v5_0.html original.

import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';

import TabProyecto   from './TabProyecto';
import TabFinanciero from './TabFinanciero';
import TabInversion  from './TabInversion';

export default function AdminProyecto() {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Paper sx={{ mb: 3, borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': { fontWeight: 600, fontSize: 15, textTransform: 'none' },
          }}
        >
          <Tab label="El proyecto" />
          <Tab label="Análisis financiero" />
          <Tab label="Propuesta de inversión" />
        </Tabs>
      </Paper>

      {tab === 0 && <TabProyecto />}
      {tab === 1 && <TabFinanciero />}
      {tab === 2 && <TabInversion />}
    </Box>
  );
}
